import { FC } from "react";
import { AccompaniedProgram } from "../components/AccompaniedProgram";
import { accompaniedProgramData } from "../configs";

export const AccompaniedProgramPage: FC = () => {
  return <AccompaniedProgram data={accompaniedProgramData}/>
};